export default function AdminFooter() {
  return (
    <footer className="mt-6 rounded-[28px] border border-slate-200 bg-white/85 px-5 py-4 shadow-sm backdrop-blur">
      <div className="flex flex-col gap-2 text-sm text-slate-500 md:flex-row md:items-center md:justify-between">
        <p className="font-medium text-slate-700">Omm Physio World Admin Panel</p>
        <p>Manage patients, staff, careers, mailbox, and clinic operations in one place.</p>
      </div>
    </footer>
  );
}

